import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Checkbox, FormHelperText } from '@material-ui/core';

const FormCheckBoxWithLabel = ({
  input,
  label,
  disabled,
  meta: { error, touched }
}) => (
  <React.Fragment>
    <FormControlLabel
      disabled={disabled}
      control={
        <Checkbox
          checked={!!input.value}
          onChange={e => {
            input.onChange(e, !input.value);
          }}
          value={input.name}
          color="primary"
        />
      }
      label={label}
    />
    {(error && touched) && <FormHelperText style={{marginTop: 0}} error={true}>{error}</FormHelperText>}
  </React.Fragment>
);

FormCheckBoxWithLabel.propTypes = {
  input: PropTypes.object,
  label: PropTypes.oneOfType([ PropTypes.node, PropTypes.string ]),
  meta: PropTypes.object,
  disabled: PropTypes.bool,
};

export default FormCheckBoxWithLabel;



// WEBPACK FOOTER //
// ./src/components/legacyForm/FormCheckBoxWithLabel.js